/**
 * PrepMe Sticky ATC — mobile add-to-cart bar
 * Shows when the main ATC button scrolls off screen (mobile only).
 */
if (!customElements.get('prepme-sticky-atc')) {
class PrepMeStickyAtc extends HTMLElement {
  connectedCallback() {
    // Only activate on mobile. Desktop handled by CSS display:none.
    if (window.innerWidth >= 750 || this.bar) return;
    this._init();
  }

  disconnectedCallback() {
    if (this.isConnected) return;
    this.variantObserver?.disconnect();
    this.visibilityObserver?.disconnect();
    this.unsubscribeVariant?.();
    window.clearTimeout(this.syncTimer);
    this.bar?.remove();
    this.bar = null;
    this.unsubscribeVariant = null;
  }

  _init() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const mainProduct = document.getElementById('MainProduct-' + sectionId);
    if (!mainProduct) return;

    // Subscription products: observe the meal-picker trigger (always visible).
    // Regular products: observe the submit button.
    const mainBtn =
      mainProduct.querySelector('#MealPickerButton-' + sectionId) ||
      mainProduct.querySelector('#ProductSubmitButton-' + sectionId);
    if (!mainBtn) return;

    // Build sticky bar DOM
    const bar = document.createElement('div');
    bar.className = 'prepme-sticky-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = [
      '<div class="prepme-sticky-bar__inner">',
        '<div class="prepme-sticky-bar__info">',
          '<div class="prepme-sticky-bar__title"></div>',
          '<div class="prepme-sticky-bar__price"></div>',
        '</div>',
        '<button class="prepme-sticky-bar__btn" type="button">',
          'Dodaj u košaricu',
        '</button>',
      '</div>'
    ].join('');
    document.body.appendChild(bar);
    this.bar = bar;

    const stickyBtn = bar.querySelector('.prepme-sticky-bar__btn');
    const stickyTitle = bar.querySelector('.prepme-sticky-bar__title');
    const stickyPrice = bar.querySelector('.prepme-sticky-bar__price');

    // Populate title from <h1> or page title
    const h1 = mainProduct.querySelector('h1');
    stickyTitle.textContent = h1 ? h1.textContent.trim() : document.title.split('–')[0].trim();

    // Sync price and button state from the live DOM
    const syncState = () => {
      // Price: prefer sale price, fallback to regular
      const priceEl =
        mainProduct.querySelector('.price-item--sale') ||
        mainProduct.querySelector('.price-item--regular');
      if (priceEl) stickyPrice.textContent = priceEl.textContent.trim();

      // Availability
      stickyBtn.disabled = mainBtn.disabled;
      const labelSpan = mainBtn.querySelector('span:not(.loading__spinner *)');
      if (labelSpan) stickyBtn.textContent = labelSpan.textContent.trim();
    };

    syncState();

    // Listen for variant changes via Dawn's PubSub (if available)
    const scheduleSync = () => {
      if (!this.isConnected || !this.bar) return;
      window.clearTimeout(this.syncTimer);
      this.syncTimer = window.setTimeout(syncState, 250);
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, scheduleSync);
    }

    // Fallback: observe the variant hidden input for mutations
    const variantInput = mainProduct.querySelector('input.product-variant-id');
    if (variantInput) {
      this.variantObserver = new MutationObserver(scheduleSync);
      this.variantObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    // Click: delegate to the real ATC button for correct form submission & spinner
    stickyBtn.addEventListener('click', () => {
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
    });

    // Show/hide via IntersectionObserver on the main ATC button
    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        const visible = !entry.isIntersecting;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
      },
      { threshold: 0.2 }
    );
    this.visibilityObserver.observe(mainBtn);
  }
}

  customElements.define('prepme-sticky-atc', PrepMeStickyAtc);
}
